'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _reactRedux = require('react-redux');

var _effects = require('redux-saga/effects');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ComboBoxTypeAhead = require('./ComboBoxTypeAhead');

var _ComboBoxTypeAhead2 = _interopRequireDefault(_ComboBoxTypeAhead);

var _Store = require('../../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _ModuleReducer = require('../../components/module/ModuleReducer');

var _SetModuleCacheAction = require('../../components/module/actions/SetModuleCacheAction');

var _SetModuleCacheAction2 = _interopRequireDefault(_SetModuleCacheAction);

var _CwLog = require('../../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [loadComboData].map(_regenerator2.default.mark);

var THRESHOLD = 1200;
var CACHE_KEY = 'comboBoxTypeAhead';

/**
 * Removes duplicates from array of objects
 * @param {any[]} array 
 * @param {string} prop 
 */
var removeDuplicates = function removeDuplicates(array, prop) {
  var cache = {};

  for (var i = 0; i < array.length; i++) {
    var value = array[i][prop];

    if (!cache[value]) {
      cache[value] = array[i];
    }
  }

  var newArray = [];
  for (var key in cache) {
    if (cache.hasOwnProperty(key)) {
      newArray.push(cache[key]);
    }
  }
  return newArray;
};

function loadComboData(id, endpoint, apiGet) {
  var state, data, timeStamp, now, timeDiff, result, error, currentItems, newItems;
  return _regenerator2.default.wrap(function loadComboData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          state = (0, _Store2.default)().getState();

          // do not attempt to make api call if already cached

          data = (0, _ModuleReducer.getModuleCache)(state.module, [CACHE_KEY, id, 'endpoints', endpoint]);

          if (!data) {
            _context.next = 4;
            break;
          }

          return _context.abrupt('return');

        case 4:

          // check timestamp to make sure not to make api call within threshold
          timeStamp = (0, _ModuleReducer.getModuleCache)(state.module, [CACHE_KEY, id, 'timestamp']);
          now = (0, _moment2.default)().valueOf();

          // if already in cache

          if (!timeStamp) {
            _context.next = 10;
            break;
          }

          timeDiff = now - timeStamp;

          // if time difference is less than threshold, then do not attempt to make api call

          if (!(timeDiff < THRESHOLD)) {
            _context.next = 10;
            break;
          }

          return _context.abrupt('return');

        case 10:
          _context.next = 12;
          return (0, _effects.put)((0, _SetModuleCacheAction2.default)([CACHE_KEY, id, 'timestamp'], now));

        case 12:
          _context.next = 14;
          return (0, _effects.call)(apiGet, endpoint);

        case 14:
          result = _context.sent;

          if (result.isSuccess) {
            _context.next = 19;
            break;
          }

          error = 'Failed to load combobox typeahead. ' + result.error;

          _CwLog2.default.error(error);
          return _context.abrupt('return');

        case 19:
          currentItems = (0, _ModuleReducer.getModuleCache)(state.module, [CACHE_KEY, id, 'items']);
          newItems = currentItems && currentItems.size > 0 ? removeDuplicates(currentItems.toJS().concat(result.response), 'id') : result.response;
          _context.next = 23;
          return (0, _effects.put)((0, _SetModuleCacheAction2.default)([CACHE_KEY, id, 'items'], newItems));

        case 23:
          _context.next = 25;
          return (0, _effects.put)((0, _SetModuleCacheAction2.default)([CACHE_KEY, id, 'endpoints', endpoint], true));

        case 25:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
};

var getId = function getId(props) {
  return props.id || props.automationName;
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var items = (0, _ModuleReducer.getModuleCache)(state.module, [CACHE_KEY, getId(ownProps), 'items']);

  return {
    items: items ? items.toJS() : []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getComboData: function getComboData(endpoint) {
      (0, _Store.runSaga)(loadComboData, getId(ownProps), endpoint, ownProps.apiGet);
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ComboBoxTypeAhead2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/comboboxtypeahead/ComboBoxTypeAheadContainer.js
// module id = 743
// module chunks = 10